export default function SelectTopicLoader() {
  return (
    <div className="bg-base-100 rounded-xl shadow-sm p-4 sm:p-6 mb-6 border border-base-300">
      <h2 className="text-xl font-medium mb-4">Select a Topic</h2>
      <div className="grid grid-cols-1 gap-y-7 sm:grid-cols-2 lg:gap-3 mb-6">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="w-full h-14 bg-base-100 animate-pulse rounded-md border border-base-300 shadow-sm"></div>
        ))}
      </div>
    </div>
  );
}